export const BROADBAND_SPA_PATHS = {
  ADDITIONAL_DEVICES: "additional-devices",
  CHECKOUT: "checkout",
};

export const BROADBAND_VENUES_NO_ADDITIONAL_DEVICES = ["afacdy", "arligf"];
